import React, { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Checkbox.module.scss';
import { useController } from 'react-hook-form';
import clsx from 'clsx';

const propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  control: PropTypes.any.isRequired,
  rules: PropTypes.any,
};

const defaultProps = {};

function Checkbox({ id, name, control, rules }) {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue: false, // ważne dla checkboxów
  });

  const [isFocused, setIsFocused] = useState(false);

  const onChange = useCallback(
    (e) => {
      field.onChange(e.target.checked);
    },
    [field]
  );

  return (
    <div
      className={clsx(
        styles.container,
        field.value && styles.checked,
        isFocused && styles.focused,
        fieldState.error && styles.validationError
      )}
    >
      <div className={styles.checkbox}>
        <input
          ref={field.ref}
          className={styles.input}
          type="checkbox"
          id={id}
          name={field.name}
          checked={!!field.value}
          onChange={onChange}
          onMouseUp={() => setIsFocused(false)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
        <div className={styles.box}>
          <svg className={clsx(styles.checkMark)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <path className="tick" fill="none" strokeLinecap="round" strokeWidth="4" d="M4 10l5 5 9-9" />
          </svg>
        </div>
      </div>
    </div>
  );
}

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default memo(Checkbox);